import React from "react";
import Slide from "../core/Slide";
import { SlideProps } from "@mui/material";

const SlideTransition = (props: SlideProps) => {
    return <Slide {...props} direction="up" />;
}

export default SlideTransition;